<template>
  <div class="body">
    <div class="head">
      <Nav :title="'预交金管理'"></Nav>
    </div>
    <div class="conter">
      <van-cell-group>
        <van-cell title="流水号" value="20201312" />
        <van-cell title="姓名" value="张三" />
        <van-cell title="年龄" value="19" />
        <van-cell title="身份证号" value="530422202002020212" />
        <van-cell title="手机号码" value="18312345678" />
        <van-cell title="预交金余额" value="200.00" />
      </van-cell-group>
    </div>
    <div class="foot">
      <div class="btn_f">
        <button class="pay">充值</button>
        <button class="detail">明细</button>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "../../components/nav";
import { cell, CellGroup } from "vant";
export default {
  components: { Nav },
  data() {
    return {};
  },
};
</script>
<style>
/* body */
.body {
  display: flex;
  flex-direction: column;
}

.van-cell{
  color:#747d8c;
}

.van-cell__title {
  font-size: 16px;
}
.van-cell__value {
  font-size: 16px;
  text-align: left;
}

/* foot */
.foot {
  display: flex;
  flex-direction: column;
}
.btn_f{
   display: flex;
   justify-content: center; 
}
.pay {
  border-radius: 999px;
  width: 343px;
  height: 42px;
  background-color: #5B8DF6;
  border: 0px;
  color: white;
  font-size: 14px;
  position: fixed;
  bottom: 20vh;
  letter-spacing: 29px;
}
.detail {
  border-radius: 999px;
  width: 343px;
  height: 42px;
  background-color: #5B8DF6;
  border: 0px;
  color: white;
  font-size: 14px;
  position: fixed;
  bottom: 10vh;
  letter-spacing: 29px;
}
</style>